export default __webpack_public_path__ + "static/media/Advocacy of the August Ones.654eb21b.jpg";